export const getTimeZoneList = [
  {
    title: 'UTC',
    field: 'UTC'
  },
  {
    title: 'IST',
    field: 'Asia/Kolkata'
  },
  {
    title: 'CST',
    field: 'America/Chicago'
  },
  {
    title: 'MST',
    field: 'America/Denver'
  },
  {
    title: 'EST',
    field: 'America/New_York'
  },
  {
    title: 'PST',
    field: 'America/Los_Angeles'
  },
  {
    title: 'ADT',
    field: 'Canada/Atlantic'
  }
];

export default getTimeZoneList;
